import { createSelector } from 'reselect';

const selectCache = (state: any) => state.membersCache;

export const selectedMembers = createSelector(
  selectCache,
  (cache: any) => cache.selected
);

export const selectMemberLoading = createSelector(
  selectCache,
  (cache: any) => cache.loading
);
export const selectedError = createSelector(
  selectCache,
  (cache: any) => cache.error
);

export const selectPaginationInfo = createSelector(
  selectCache,
  (cache: any) => cache.paginationInfo
);

export const selectOrgListByBoundary = createSelector(
  selectCache,
  (cache: any) => cache.orgListByBoundary
);
